import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { CLDR } from '@phensley/cldr';
import { CLDRService } from '../services/cldr/cldr.service';

@Pipe({
    name: 'abbreviateNumber',
    standalone: true
})
export class AbbreviateNumberPipe implements PipeTransform {
    constructor(private cldrService: CLDRService) {}

    /**
     * Transforms a given number to its abbreviated form using @phensley/cldr, appending a suffix ('K' or 'M') if needed.
     */
    transform(value: number, fractionDigits = 2): Observable<string> {
        return this.cldrService.cldr$.pipe(
            map((cldr: CLDR) => {
                return cldr.Numbers.formatDecimal(value, { style: 'short' });
            })
        );
    }
}
